// src/Features/HotelList/HotelFilters.jsx
import React, { useState, useMemo, useEffect } from "react";
import { Form, Accordion } from "react-bootstrap";
import ReactRating from "react-rating";
import { Star, StarFill } from "react-bootstrap-icons";
import Slider from "@mui/material/Slider";
import "./HotelFilters.css";
import Cookies from "js-cookie";
import { useTranslation } from "../../../../contexts/TranslationContext";



/* ============== PriceRange (MUI Slider) ============== */
function PriceRange({ min, max, value, onValueChange }) {

  const step = 10;
  const clamp = (n, lo, hi) => Math.min(Math.max(Number(n || 0), lo), hi);

  const handleChange = (_, newValue) => {
    const a = clamp(newValue[0], min, max - step);
    const b = clamp(newValue[1], min + step, max);
    const lo = Math.min(a, b - step);
    const hi = Math.max(b, lo + step);
    onValueChange([lo - (lo % step), hi - (hi % step)]);
  };

  return (
    <div className="price-range">
      <Slider
        value={value}
        onChange={handleChange}
        valueLabelDisplay="on"
        valueLabelFormat={(v) => `$${v}`}
        min={min}
        max={max}
        step={step}
        disableSwap
        aria-label="Price range"
        sx={{
          color: "#23459B",
          height: 6,
          "& .MuiSlider-thumb": { width: 16, height: 16 },
          "& .MuiSlider-valueLabel": {
            fontSize: 12,
            background: "#23459B",
            borderRadius: "4px",
          },
          "& .MuiSlider-rail": { backgroundColor: "#e5e7eb", opacity: 1 },
        }}
      />
      <div className="hf-range-inputs">
        <Form.Control
          size="sm"
          type="number"
          min={min}
          max={max - step}
          step={step}
          value={value[0]}
          onChange={(e) => onValueChange([+e.target.value, value[1]])}
        />
        <Form.Control
          size="sm"
          type="number"
          min={min + step}
          max={max}
          step={step}
          value={value[1]}
          onChange={(e) => onValueChange([value[0], +e.target.value])}
        />
      </div>
    </div>
  );
}

const AMENITIES = [
  "Motels",
  "Kitchen/Kitchenette",
  "Breakfast Included",
  "Apartments",
  "Free Wifi",
];

/* ============== HotelFilters (Accordion + Search خارجي) ============== */
export default function HotelFilters({ value, onChange }) {

  const Lang = Cookies.get("preferred_language") || "en";
  const min = 0, max = 300;
  const { t } = useTranslation();

  const amenitiesSet = useMemo(
    () => new Set((value.amenities || "").split(",").filter(Boolean)),
    [value.amenities]
  );

  const toggleAmenity = (name) => {
    const set = new Set(amenitiesSet);
    set.has(name) ? set.delete(name) : set.add(name);
    onChange({ amenities: Array.from(set).join(",") });
  };

  const [range, setRange] = useState([
    Number(value.minPrice) || min,
    Number(value.maxPrice) || max,
  ]);
  useEffect(() => {
    setRange([Number(value.minPrice) || min, Number(value.maxPrice) || max]);
  }, [value.minPrice, value.maxPrice]);

 const handleRange = (arr) => {
    setRange(arr);
    onChange({ minPrice: String(arr[0]), maxPrice: String(arr[1]) });
  };


  useEffect(() => {

  }, [value.minRating, value.refundable, value.minPrice, value.maxPrice, value.amenities]);

  return (
    <aside className="filters hotel-filters">
      <div className="filter">
        {/* Header */}
        <div className="filter-header">
          <div className="filter-title d-none	d-xl-block ">{t("FilterBy")}</div>
        </div>
{/* 
        <div className="search-field mb-3">
          <input
            type="text"
            placeholder="Search"
            className="filter-search"
            // value={value.q}
            // onChange={(e) => onChange({ q: e.target.value })}
          />
        </div> */}

        <div className="divider" />

        <Accordion
          defaultActiveKey={["price", "amenities", "rate"]}
          alwaysOpen
        >
          {/* PRICE */}
          {/* <Accordion.Item eventKey="price" className="hf-accordion-item">
            <Accordion.Header>Price</Accordion.Header>
            <Accordion.Body>
              <PriceRange
                min={min}
                max={max}
                value={range}
                onValueChange={handleRange}
              />
            </Accordion.Body>
          </Accordion.Item> */}

          {/* REFUNDABLE */}
          {/* <div className="divider" /> */}

          <div className="checkbox-container">
            <input
              type="checkbox"
              className="custom-checkbox"
              checked={value.refundable === "true"}
              onChange={(e) =>
                onChange({ refundable: String(e.target.checked) })
              }
              id="hf-refundable"
            />
            <label className="checkbox-label-products" htmlFor="hf-refundable">
              {t("Refundable")}
            </label>
          </div>

                    <div className="divider" />


          {/* AMENITIES */}
          {/* <Accordion.Item eventKey="amenities" className="hf-accordion-item">
            <Accordion.Header>Amenities</Accordion.Header>
            <Accordion.Body>
              <div className="brand-filter">
                {AMENITIES.map((a) => (
                  <div className="check-items" key={a}>
                    <input
                      type="checkbox"
                      className="custom-checkbox"
                      checked={amenitiesSet.has(a)}
                      onChange={() => toggleAmenity(a)}
                      id={`amen-${a}`}
                    />
                    <label className="check-items-label" htmlFor={`amen-${a}`}>
                      {a}
                    </label>
                  </div>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>

                    <div className="divider" /> */}


          {/* RATE */}
         <Accordion.Item eventKey="rate" className="hf-accordion-item">
          <Accordion.Header>{t("Rate")}</Accordion.Header>
          <Accordion.Body>
            {[5, 4, 3, 2, 1].map((n) => (
              <div className="checkbox-container" key={n}>
                <input
                  type="checkbox"
                  className="custom-checkbox"
                  checked={Number(value.minRating) === n}
                  onChange={() =>
                    onChange({
                      minRating: String(
                        Number(value.minRating) === n ? 0 : n
                      ),
                    })
                  }
                  id={`rate-${n}`}
                />
                <label htmlFor={`rate-${n}`} className="me-2" />
                <ReactRating
                  initialRating={n}
                  readonly
                  emptySymbol={<Star size={18} color="#c48a27" />}
                  fullSymbol={<StarFill size={18} color="#c48a27" />}
                />
                {/* <span className={`${Lang === "en" ? "ms-2" : "me-2"}`}>{n} {t("Stars")}{n !== 1 ? 's' : ''}</span> */}
                <span className={`${Lang === "en" ? "ms-2" : "me-2"}`}>
                  {n} {n === 1 ? t("Star") : t("Stars")}
                </span>
              </div>
            ))}
          </Accordion.Body>
        </Accordion.Item>
        </Accordion>
      </div>
    </aside>
  );
}
